<app-step-header [title]="step().title"
                 [description]="step().description"
                 [state]="state()"
></app-step-header>
<div class="adaptive-card" #container [class.completed]="state().readonly"></div>
